import { useSession } from "next-auth/react";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import Header from "./header";
import Footer from "./navigation/Footer";
import TopNav from "./navigation/TopNav";
import { ToastContainer } from "react-toastify";
import { Sidebar } from "../components/Sidebar";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import InstagramIcon from "@mui/icons-material/Instagram";
import BusinessIcon from "@mui/icons-material/Business";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import SupportIcon from "@mui/icons-material/Support";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import DeviceHubOutlinedIcon from "@mui/icons-material/DeviceHubOutlined";
import FaceRetouchingNaturalOutlinedIcon from "@mui/icons-material/FaceRetouchingNaturalOutlined";
import SettingsSuggestOutlinedIcon from "@mui/icons-material/SettingsSuggestOutlined";
import PendingActionsOutlinedIcon from "@mui/icons-material/PendingActionsOutlined";
import WebhookOutlinedIcon from "@mui/icons-material/WebhookOutlined";
import ApiOutlinedIcon from "@mui/icons-material/ApiOutlined";
import DnsOutlinedIcon from "@mui/icons-material/DnsOutlined";
import BoltOutlinedIcon from "@mui/icons-material/BoltOutlined";
import MarkChatReadOutlinedIcon from "@mui/icons-material/MarkChatReadOutlined";
import ApartmentOutlinedIcon from "@mui/icons-material/ApartmentOutlined";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import PriceChangeOutlinedIcon from "@mui/icons-material/PriceChangeOutlined";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import LockPersonOutlinedIcon from "@mui/icons-material/LockPersonOutlined";
import LockOpenOutlinedIcon from "@mui/icons-material/LockOpenOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import GppGoodOutlinedIcon from "@mui/icons-material/GppGoodOutlined";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import ContactPageOutlinedIcon from "@mui/icons-material/ContactPageOutlined";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import ScheduleSendOutlinedIcon from "@mui/icons-material/ScheduleSendOutlined";
import QuickreplyOutlinedIcon from "@mui/icons-material/QuickreplyOutlined";
import KeyboardVoiceOutlinedIcon from "@mui/icons-material/KeyboardVoiceOutlined";
import SwitchAccountOutlinedIcon from "@mui/icons-material/SwitchAccountOutlined";
import Groups3OutlinedIcon from "@mui/icons-material/Groups3Outlined";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import SmartButtonOutlinedIcon from "@mui/icons-material/SmartButtonOutlined";
import PersonSearchOutlinedIcon from "@mui/icons-material/PersonSearchOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import SendTimeExtensionOutlinedIcon from "@mui/icons-material/SendTimeExtensionOutlined";
import SmartToyOutlinedIcon from "@mui/icons-material/SmartToyOutlined";
import MovieEditIcon from "@mui/icons-material/MovieEdit";
import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import TokenOutlinedIcon from "@mui/icons-material/TokenOutlined";
import RocketLaunchOutlinedIcon from "@mui/icons-material/RocketLaunchOutlined";
import HubOutlinedIcon from "@mui/icons-material/HubOutlined";
import PhotoFilterOutlinedIcon from "@mui/icons-material/PhotoFilterOutlined";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import StoreOutlinedIcon from "@mui/icons-material/StoreOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import ReplyOutlinedIcon from "@mui/icons-material/ReplyOutlined";
import SchemaOutlinedIcon from "@mui/icons-material/SchemaOutlined";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import ViewKanbanOutlinedIcon from "@mui/icons-material/ViewKanbanOutlined";
import TroubleshootOutlinedIcon from "@mui/icons-material/TroubleshootOutlined";
import WidgetsIcon from "@mui/icons-material/Widgets";
import SmsOutlinedIcon from "@mui/icons-material/SmsOutlined";
import WabaCallWidget from "../components/WabaCallWidget";
import MusicNoteOutlinedIcon from "@mui/icons-material/MusicNoteOutlined";
import MessageNotificationWidget from "../components/MessageNotificationWidget";
import MailOutlinedIcon from "@mui/icons-material/MailOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { useState } from "react";
import {
  getCompanyRouteAccess,
  toCompanyValueSet,
} from "@lib/companyPermissionCatalog.mjs";

const AuthLayout = ({
  children,
  showMobilemenu,
  hideFooter = false,
  hideTopbar = false,
  noContainer = false,
  embed = false,
}) => {
  const { data: session, status: sessionStatus } = useSession();
  const { t } = useTranslation("common");
  const router = useRouter();
  const location = router.pathname;

  const currentPermissions = toCompanyValueSet(
    session?.user?.currentCompany?.user_permissions,
  );
  const currentAccessBlocks = toCompanyValueSet(
    session?.user?.currentCompany?.access_blocks,
  );
  const isPlatformAdmin = session?.user?.role === "admin";
  const isCompanyOwner = session?.user?.currentCompany?.owner === true;

  const canAccessFeature = (blockKey, permissionKey) => {
    const hasPermission =
      currentPermissions.has(permissionKey) || isPlatformAdmin || isCompanyOwner;
    if (blockKey !== "forms") return hasPermission;
    return hasPermission && (isPlatformAdmin || isCompanyOwner || currentAccessBlocks.has("forms"));
  };

  const routeAccess = getCompanyRouteAccess(location);
  const requiredPermissions = routeAccess?.permissions || [];
  const alternativePermissions = routeAccess?.anyPermissions || [];
  const hasRoutePermission =
    requiredPermissions.every((permission) =>
      currentPermissions.has(permission),
    ) &&
    (alternativePermissions.length === 0 ||
      alternativePermissions.some((permission) =>
        currentPermissions.has(permission),
      ));
  const hasRouteRoleAccess =
    isPlatformAdmin || isCompanyOwner || hasRoutePermission;
  const hasRouteLicense =
    !routeAccess?.accessBlock ||
    isPlatformAdmin ||
    currentAccessBlocks.has(routeAccess.accessBlock);
  const isRouteSessionLoading =
    Boolean(routeAccess) && sessionStatus === "loading";
  const hasAuthenticatedSession =
    sessionStatus === "authenticated" && Boolean(session?.user);
  const canAccessCurrentRoute =
    !routeAccess ||
    (hasAuthenticatedSession && hasRouteRoleAccess && hasRouteLicense);

  const renderedChildren = isRouteSessionLoading ? (
    <div className="tw-p-3 text-muted" role="status" aria-live="polite">
      {t("common:loading", { defaultValue: "Loading..." })}
    </div>
  ) : canAccessCurrentRoute ? (
    children
  ) : !hasRouteLicense ? (
    <div className="alert alert-warning tw-m-3">
      <strong>{t("common:subscription.locked.title")}</strong>
      <div className="small tw-mt-1">
        {t("common:subscription.locked.desc")}
      </div>
    </div>
  ) : (
    <div className="alert alert-warning tw-m-3">
      <strong>
        {t("common:permission-denied-title", {
          defaultValue: "Acesso não permitido",
        })}
      </strong>
      <div className="small tw-mt-1">
        {t("common:permission-denied-description", {
          defaultValue:
            "O seu cargo não possui as permissões necessárias para acessar este módulo.",
        })}
      </div>
    </div>
  );

  // Build sidebar items based on user role and permissions
  const buildSidebarItems = () => {
    const items = [];

    // Dashboard - for all users
    items.push({
      id: "dashboard",
      icon: <AssessmentOutlinedIcon />,
      label: t("common:menu.dashboard"),
      url: "/dashboard",
      isRouteActive:
        location === "/dashboard" || location.includes("/dashboard"),
    });

    // Companies menu - for all users
    items.push({
      id: "companies",
      icon: <ApartmentOutlinedIcon />,
      label: t("common:menu.companies"),
      url: "/companies",
      isRouteActive: location.includes("/companies"),
    });

    // All companies menu - for admin only
    if (session?.user?.role === "admin") {
      items.push({
        id: "all-companies",
        icon: <BusinessOutlinedIcon />,
        label: t("common:menu.all-companies"),
        url: "/all-companies",
        isRouteActive: location.includes("/all-companies"),
      });


      // Subscription and invoices - for admin only
      items.push({
        id: "subscriptions-mgmt",
        icon: <PaymentsOutlinedIcon />,
        label: t("common:menu.subscriptions"),
        isRouteActive:
          location.includes("/admin/invoices") ||
          location.includes("/admin/subscription-plans") ||
          location.includes("/admin/auto-renew"),
        children: [
          {
            id: "subscription-plans",
            icon: <PriceChangeOutlinedIcon />,
            label: t("common:menu.subscription-plans"),
            url: "/admin/subscription-plans",
            isRouteActive: location.includes("/admin/subscription-plans"),
          },
          {
            id: "customer-invoices",
            icon: <ReceiptOutlinedIcon />,
            label: t("common:menu.customer-invoices"),
            url: "/admin/invoices",
            isRouteActive: location.includes("/admin/invoices"),
          },
          {
            id: "auto-renewal",
            icon: <PublishedWithChangesIcon />,
            label: t("common:menu.auto-renew"),
            url: "/admin/auto-renew",
            isRouteActive: location.includes("/admin/auto-renew"),
          },
        ],
      });

      // User management - for admin only
      items.push({
        id: "user-management",
        icon: <ManageAccountsOutlinedIcon />,
        label: t("common:menu.user-management"),
        isRouteActive:
          location.includes("/admin/company-permissions") ||
          location.includes("/admin/permissions") ||
          location.includes("/admin/roles") ||
          location.includes("/admin/users/"),
        children: [
          {
            id: "roles",
            icon: <AdminPanelSettingsOutlinedIcon />,
            label: t("common:menu.roles"),
            url: "/admin/roles",
            isRouteActive:
              location === "/admin/roles" || location.includes("/admin/roles"),
          },
          {
            id: "permissions",
            icon: <LockPersonOutlinedIcon />,
            label: t("common:menu.permissions"),
            url: "/admin/permissions",
            isRouteActive:
              location === "/admin/permissions" ||
              location.includes("/admin/permissions"),
          },
          {
            id: "company-permissions",
            icon: <LockOpenOutlinedIcon />,
            label: t("common:menu.company-permissions"),
            url: "/admin/company-permissions",
            isRouteActive:
              location === "/admin/company-permissions" ||
              location.includes("/admin/company-permissions"),
          },
          {
            id: "customers",
            icon: <PeopleAltOutlinedIcon />,
            label: t("common:menu.customers"),
            url: "/admin/users/customers",
            isRouteActive:
              location === "/admin/users/customers" ||
              location.includes("/admin/users/customers"),
          },
          {
            id: "customer-support",
            icon: <SupportAgentIcon />,
            label: t("common:menu.customer-support"),
            url: "/admin/users/customer-support",
            isRouteActive:
              location === "/admin/users/customer-support" ||
              location.includes("/admin/users/customer-support"),
          },
          {
            id: "admins",
            icon: <GppGoodOutlinedIcon />,
            label: t("common:menu.admins"),
            url: "/admin/users/admins",
            isRouteActive:
              location === "/admin/users/admins" ||
              location.includes("/admin/users/admins"),
          },
        ],
      });

      // Video- Tutorials - for admin only
      items.push({
        id: "video-tutorials",
        icon: <MovieEditIcon />,
        label: t("common:menu.video-tutorials"),
        url: "/admin/video-tutorials",
        isRouteActive:
          location === "/admin/video-tutorials" ||
          location.includes("/admin/video-tutorials"),
      });
    }

    // Company specific items
    if (session?.user?.currentCompany) {
      // Integrations
      if (canAccessFeature("channels", "channels.view", session)) {
        items.push({
        id: "channels",
        icon: <DeviceHubOutlinedIcon />,
        label: t("common:menu.channels"),
        isRouteActive: location.includes("/channels/"),
        children: [
          {
            id: "whatsapp-integration",
            icon: <WhatsAppIcon />,
            label: t("common:menu.web-whatsapp"),
            url: "/channels/web-whatsapp",
            isRouteActive: location === "/channels/web-whatsapp",
          },
          {
            id: "waba-accounts",
            icon: <WhatsAppIcon />,
            label: t("common:menu.waba-accounts"),
            url: "/channels/whatsapp",
            isRouteActive: location === "/channels/whatsapp",
          },
          {
            id: "message-templates",
            icon: <MarkChatReadOutlinedIcon />,
            label: t("common:menu.message-templates"),
            url: "/channels/whatsapp/templates",
            isRouteActive: location.includes("/channels/whatsapp/templates"),
          },

          {
            id: "instagram-integration",
            icon: <InstagramIcon />,
            label: t("common:menu.instagram"),
            url: "/channels/instagram",
            isRouteActive:
              location === "/channels/instagram" ||
              location.includes("/channels/instagram/templates") ||
              location.includes("/channels/instagram/embedded-signup"),
          },
          {
            id: "2bebot-integration",
            icon: <WhatsAppIcon />,
            label: t("common:menu.2bebot"),
            url: "/channels/2bebot",
            isRouteActive: location === "/channels/2bebot",
          },
          {
            id: "messenger-integration",
            icon: <SmsOutlinedIcon />,
            label: t("common:menu.messenger"),
            url: "/channels/messenger",
            isRouteActive: location === "/channels/messenger",
          },
          {
            id: "email-channels",
            icon: <MailOutlinedIcon />,
            label: t("common:menu.email-channels"),
            url: "/channels/email",
            isRouteActive:
              location === "/channels/email" &&
              !location.includes("/channels/email/templates"),
          },
          {
            id: "email-templates",
            icon: <DescriptionOutlinedIcon />,
            label: t("common:menu.email-templates"),
            url: "/channels/email/templates",
            isRouteActive: location.includes("/channels/email/templates"),
          },
          {
            id: "sms-gate",
            icon: <SmsOutlinedIcon />,
            label: t("common:menu.sms-gate"),
            url: "/channels/sms-gate",
            isRouteActive:
              location === "/channels/sms-gate" ||
              location.includes("/channels/sms-gate/connect"),
          },

          // ...(session?.user?.currentCompany?.integrations.includes(
          //   "tiktok",
          // ) || session?.user?.role === "admin"
          //   ? [
          //       {
          //         id: "tiktok",
          //         icon: <MusicNoteOutlinedIcon />,
          //         label: t("common:menu.tiktok"),
          //         url: "/channels/tiktok",
          //         isRouteActive:
          //           location === "/channels/tiktok" ||
          //           location.includes("/channels/tiktok/connect"),
          //       },
          //     ]
          //   : []),

          {
            id: "website-integration",
            icon: <WidgetsIcon />,
            label: t("common:menu.website"),
            url: "/channels/website",
            isRouteActive: location === "/channels/website",
          },
        ],
        });
      }

      // Keep Inbox and Kanban as dedicated, consecutive sidebar entries.
      if (canAccessFeature("inbox", "inbox.view", session)) {
        items.push({
          id: "whatsapp-chat",
          icon: <ForumOutlinedIcon />,
          label: t("common:menu.whatsapp-chat"),
          url: "/channels/inbox?tab=chats",
          isRouteActive:
            location.includes("/channels/inbox") &&
            router.query.tab !== "kanban",
        });

        items.push({
          id: "inbox-kanban",
          icon: <ViewKanbanOutlinedIcon />,
          label: t("common:menu.kanban-funnel"),
          url: "/channels/inbox?tab=kanban",
          isRouteActive:
            location.includes("/channels/inbox") &&
            router.query.tab === "kanban",
        });
      }

      // Contacts
      if (canAccessFeature("contacts", "contacts.view", session)) {
        items.push({
        id: "contacts",
        icon: <ContactPageOutlinedIcon />,
        label: t("common:menu.contacts"),
        url: "/company/contacts",
        isRouteActive:
          location === "/company/contacts" ||
          location.includes("/company/contacts"),
        });
      }

      // Groups
      items.push({
        id: "groups",
        icon: <Groups3OutlinedIcon />,
        label: t("common:menu.groups"),
        url: "/company/groups",
        isRouteActive:
          location === "/company/groups" ||
          location.includes("/company/groups"),
      });

      // Smart agent module
      if (canAccessFeature("smart_agent", "smart_agent.view", session)) {
        items.push({
          id: "smart-reply",
          icon: <FaceRetouchingNaturalOutlinedIcon />,
          label: t("common:menu.smart-reply"),
          isRouteActive:
            location.includes("/smart-agent/agents") ||
            location.includes("/smart-agent/all-agents") ||
            location.includes("/smart-agent/tools") ||
            location.includes("/smart-agent/voices") ||
            location.includes("/smart-agent/library") ||
            location.includes("/calendar") ||
            location.includes("/smart-agent/knowledge-base"),
          children: [
            {
              id: "agents",
              icon: <FaceRetouchingNaturalOutlinedIcon />,
              label: t("common:menu.agents"),
              url: "/smart-agent/agents",
              isRouteActive:
                location === "/smart-agent/agents" ||
                location.includes("/smart-agent/agents"),
            },
            {
              id: "knowledge-base",
              icon: <SchoolOutlinedIcon />,
              label: t("common:menu.knowledge-base"),
              url: "/smart-agent/knowledge-base",
              isRouteActive:
                location === "/smart-agent/knowledge-base" ||
                location.includes("/smart-agent/knowledge-base"),
            },
            {
              id: "smart-tools",
              icon: <SettingsSuggestOutlinedIcon />,
              label: t("common:menu.smart-tools"),
              url: "/smart-agent/tools",
              isRouteActive:
                location === "/smart-agent/tools" ||
                location.includes("/smart-agent/tools"),
            },
            {
              id: "voice",
              icon: <KeyboardVoiceOutlinedIcon />,
              label: t("common:menu.voice"),
              url: "/smart-agent/voices",
              isRouteActive:
                location === "/smart-agent/voices" ||
                location.includes("/smart-agent/voices"),
            },
            {
              id: "calendar",
              icon: <CalendarMonthOutlinedIcon />,
              label: t("common:menu.calendar"),
              url: "/calendar",
              isRouteActive:
                location === "/calendar" || location.includes("/calendar"),
            },
            // Admin only
            ...(session?.user?.role === "admin"
              ? [
                  {
                    id: "all-agents",
                    icon: <SwitchAccountOutlinedIcon />,
                    label: t("common:menu.all-agents"),
                    url: "/smart-agent/all-agents",
                    isRouteActive:
                      location === "/smart-agent/all-agents" ||
                      location.includes("/smart-agent/all-agents"),
                  },
                  // Agents library
                  {
                    id: "agents-library",
                    icon: <Groups3OutlinedIcon />,
                    label: t("common:menu.agent-library"),
                    url: "/smart-agent/library",
                    isRouteActive:
                      location === "/smart-agent/library" ||
                      location.includes("/smart-agent/library"),
                  },
                ]
              : []),
          ],
        });
      }

      // Bulk sending
      if (canAccessFeature("bulk_sending", "campaigns.view", session)) {
        items.push({
          id: "bulk-sending",
          icon: <RocketLaunchOutlinedIcon />,
          label: t("common:menu.bulk-sending"),
          isRouteActive:
            location.includes("/company/messages") ||
            location.includes("/company/campaigns") ||
            location.includes("/all-campaigns") ||
            location.includes("/company/actions") ||
            location.includes("/smart-agent/auto-reply") ||
            location.includes("/quick-reply"),
          children: [
            {
              id: "messages",
              icon: <SchemaOutlinedIcon />,
              label: t("common:menu.messages"),
              url: "/company/messages",
              isRouteActive:
                location === "/company/messages" ||
                location.includes("/company/messages"),
            },
            {
              id: "my-campaigns",
              icon: <ScheduleSendOutlinedIcon />,
              label: t("common:menu.my-campaigns"),
              url: "/company/campaigns",
              isRouteActive:
                location === "/company/campaigns" ||
                location.includes("/company/campaigns"),
            },
            {
              id: "actions",
              icon: <BoltOutlinedIcon />,
              label: t("common:menu.actions"),
              url: "/company/actions",
              isRouteActive:
                location === "/company/actions" ||
                location.includes("/company/actions"),
            },
            {
              id: "auto-reply",
              icon: <QuickreplyOutlinedIcon />,
              label: t("common:menu.auto-reply"),
              url: "/smart-agent/auto-reply",
              isRouteActive:
                location === "/smart-agent/auto-reply" ||
                location.includes("/smart-agent/auto-reply"),
            },
            {
              id: "quick-reply",
              icon: <ReplyOutlinedIcon />,
              label: t("common:menu.quick-reply"),
              url: "/quick-reply",
              isRouteActive:
                location === "/quick-reply" ||
                location.includes("/quick-reply"),
            },
            // Admin only
            ...(session?.user?.role === "admin"
              ? [
                  {
                    id: "all-campaigns",
                    icon: <PendingActionsOutlinedIcon />,
                    label: t("common:menu.all-campaigns"),
                    url: "/all-campaigns",
                    isRouteActive:
                      location === "/all-campaigns" ||
                      location.includes("/all-campaigns"),
                  },
                ]
              : []),
          ],
        });
      }

      // Reusable multichannel forms
      if (canAccessFeature("forms", "forms.view", session) || canAccessFeature("forms", "forms.manage", session)) {
        items.push({
          id: "forms",
          icon: <DescriptionOutlinedIcon />,
          label: t("common:menu.forms"),
          url: "/forms",
          isRouteActive:
            location === "/forms" ||
            location.includes("/forms") ||
            location === "/admin/leads" ||
            location.includes("/admin/leads/metrics") ||
            location.includes("/admin/leads/forms"),
          children: [
            {
              id: "forms-list",
              icon: <DescriptionOutlinedIcon />,
              label: t("common:menu.forms"),
              url: "/forms",
              isRouteActive: location === "/forms" || location.includes("/forms/"),
            },
            {
              id: "forms-leads",
              icon: <PersonSearchOutlinedIcon />,
              label: t("common:menu.lead-forms"),
              url: "/admin/leads",
              isRouteActive:
                location === "/admin/leads" ||
                location.includes("/admin/leads/metrics"),
            },
            ...(session?.user?.role === "admin"
              ? [{
                  id: "forms-ai",
                  icon: <SmartToyOutlinedIcon />,
                  label: t("common:menu.ai-forms"),
                  url: "/admin/leads/forms",
                  isRouteActive: location.includes("/admin/leads/forms"),
                }]
              : []),
          ],
        });
      }
      // workflows
      if (canAccessFeature("workflows", "workflows.view", session)) {
        items.push({
          id: "workflows",
          icon: <AccountTreeOutlinedIcon />,
          label: t("common:menu.workflows"),
          url: "/workflows",
          isRouteActive:
            location === "/workflows" || location.includes("/workflows"),
        });
      }

      if (canAccessFeature("sales_payments", "sales_payments.view", session)) {
        items.push({
          id: "sales-acquisition",
          icon: <PaidOutlinedIcon />,
          label: t("common:menu.sales-acquisition"),
          isRouteActive:
            location.includes("/company/acquisition") ||
            location.includes("/company/customer-payments"),
          children: [
            {
              id: "customer-acquisition",
              icon: <AssessmentOutlinedIcon />,
              label: t("common:menu.acquisition"),
              url: "/company/acquisition",
              isRouteActive:
                location === "/company/acquisition" ||
                location.includes("/company/acquisition/"),
            },
            {
              id: "sales-payments",
              icon: <PaidOutlinedIcon />,
              label: t("common:menu.sales-payments"),
              url: "/company/customer-payments",
              isRouteActive:
                location === "/company/customer-payments" ||
                location.includes("/company/customer-payments"),
            },
          ],
        });
      }

      // Automations
      if (canAccessFeature("automations", "automations.view", session)) {
        items.push({
          id: "automations",
          icon: <HubOutlinedIcon />,
          label: t("common:menu.integrations"),
          isRouteActive:
            location.includes("/company/webhook-callback") ||
            location.includes("/admin/webhook-callback") ||
            location.includes("/admin/workflow-templates") ||
            location.includes("/admin/funnel-templates") ||
            location.includes("/company/tracking") ||
            location.includes("/company/mcp") ||
            location.includes("/company/apis"),
          children: [
            // Templates first, then connections, APIs and monitoring.
            ...(session?.user?.role === "admin"
              ? [
                  {
                    id: "workflow-templates",
                    icon: <AccountTreeOutlinedIcon />,
                    label: t("common:menu.workflow-templates"),
                    url: "/admin/workflow-templates",
                    isRouteActive:
                      location === "/admin/workflow-templates" ||
                      location.includes("/admin/workflow-templates"),
                  },
                  {
                    id: "funnel-templates",
                    icon: <FilterAltOutlinedIcon />,
                    label: t("common:menu.funnel-templates"),
                    url: "/admin/funnel-templates",
                    isRouteActive:
                      location === "/admin/funnel-templates" ||
                      location.includes("/admin/funnel-templates/"),
                  },
                  {
                    id: "webhook-templates",
                    icon: <TokenOutlinedIcon />,
                    label: t("common:menu.webhook-templates"),
                    url: "/admin/webhook-callback/templates",
                    isRouteActive:
                      location === "/admin/webhook-callback/templates" ||
                      location.includes("/admin/webhook-callback/templates"),
                  },
                  {
                    id: "payment-integrations",
                    icon: <CurrencyExchangeIcon />,
                    label: t("common:menu.payments-integration"),
                    url: "/admin/payment-integrations",
                    isRouteActive:
                      location === "/admin/payment-integrations" ||
                      location.includes("/admin/payment-integrations"),
                  },
                ]
              : []),
            {
              id: "webhook-integrations",
              icon: <WebhookOutlinedIcon />,
              label: t("common:menu.webhook-integrations"),
              url: "/company/webhook-integrations",
              isRouteActive:
                location === "/company/webhook-integrations" ||
                location.includes("/company/webhook-integrations"),
            },
            {
              id: "apis",
              icon: <ApiOutlinedIcon />,
              label: t("common:menu.apis"),
              url: "/company/apis",
              isRouteActive:
                location === "/company/apis" ||
                location.includes("/company/apis"),
            },
            {
              id: "mcp",
              icon: <DnsOutlinedIcon />,
              label: t("common:menu.mcp"),
              url: "/company/mcp",
              isRouteActive:
                location === "/company/mcp" ||
                location.includes("/company/mcp/"),
            },
            ...(canAccessFeature("automations", "tracking.view", session) ||
              canAccessFeature("automations", "tracking.manage", session)
              ? [
                  {
                    id: "tracking",
                    icon: <TroubleshootOutlinedIcon />,
                    label: t("common:menu.tracking"),
                    url: "/company/tracking",
                    isRouteActive:
                      location === "/company/tracking" ||
                      location.includes("/company/tracking/"),
                  },
                ]
              : []),
          ],
        });
      }
    }

    // Admin specific items
    if (session?.user?.role === "admin") {
      // External APIs
      items.push({
        id: "bsmart-management",
        icon: <PhotoFilterOutlinedIcon />,
        label: t("common:menu.bsmart-management"),
        isRouteActive:
          location.includes("/external/partner-management") ||
          location.includes("/external/models-management") ||
          location.includes("/external/company-management") ||
          location.includes("/external/agent-management") ||
          location.includes("/external/voice-management") ||
          location.includes("/external/credit-prices"),
        children: [
          {
            id: "partner-management",
            icon: <HandshakeOutlinedIcon />,
            label: t("common:menu.partner-management"),
            url: "/external/partner-management",
            isRouteActive:
              location === "/external/partner-management" ||
              location.includes("/external/partner-management"),
          },
          {
            id: "models-management",
            icon: <SmartButtonOutlinedIcon />,
            label: t("common:menu.models-management"),
            url: "/external/models-management",
            isRouteActive:
              location === "/external/models-management" ||
              location.includes("/external/models-management"),
          },
          {
            id: "credit-prices",
            icon: <PriceChangeOutlinedIcon />,
            label: t("common:menu.credit-prices"),
            url: "/external/credit-prices",
            isRouteActive:
              location === "/external/credit-prices" ||
              location.includes("/external/credit-prices"),
          },
          {
            id: "company-management",
            icon: <BusinessIcon />,
            label: t("common:menu.company-management"),
            url: "/external/company-management",
            isRouteActive:
              location === "/external/company-management" ||
              location.includes("/external/company-management"),
          },
          {
            id: "agent-management",
            icon: <SwitchAccountOutlinedIcon />,
            label: t("common:menu.agent-management"),
            url: "/external/agent-management",
            isRouteActive:
              location === "/external/agent-management" ||
              location.includes("/external/agent-management"),
          },
          {
            id: "voice-management",
            icon: <KeyboardVoiceOutlinedIcon />,
            label: t("common:menu.voice-management"),
            url: "/external/voice-management",
            isRouteActive:
              location === "/external/voice-management" ||
              location.includes("/external/voice-management"),
          },
        ],
      });

      // Settings
      items.push({
        id: "settings",
        icon: <TuneOutlinedIcon />,
        label: t("common:menu.settings"),
        isRouteActive:
          location.includes("/admin/whatsapp-channels") ||
          location.includes("/admin/messages") ||
          location.includes("/admin/campaigns") ||
          location.includes("/settings/general") ||
          location.includes("/settings/system-emails"),
        children: [
          {
            id: "general",
            icon: <SettingsOutlinedIcon />,
            label: t("common:menu.general"),
            url: "/settings/general",
            isRouteActive:
              location === "/settings/general" ||
              location.includes("/settings/general"),
          },
          {
            id: "system-emails",
            icon: <SendTimeExtensionOutlinedIcon />,
            label: t("common:menu.system-emails"),
            url: "/settings/system-emails",
            isRouteActive:
              location === "/settings/system-emails" ||
              location.includes("/settings/system-emails"),
          },
          {
            id: "whatsapp-settings",
            icon: <WhatsAppIcon />,
            label: t("common:menu.whatsapp"),
            url: "/admin/whatsapp-channels",
            isRouteActive:
              location === "/admin/whatsapp-channels" ||
              location.includes("/admin/whatsapp-channels"),
          },
          {
            id: "messages-settings",
            icon: <SchemaOutlinedIcon />,
            label: t("common:menu.messages"),
            url: "/admin/messages",
            isRouteActive:
              location === "/admin/messages" ||
              location.includes("/admin/messages"),
          },
          {
            id: "system-campaigns",
            icon: <ScheduleSendOutlinedIcon />,
            label: t("common:menu.system-campaigns"),
            url: "/admin/campaigns",
            isRouteActive:
              location === "/admin/campaigns" ||
              location.includes("/admin/campaigns"),
          },
        ],
      });
    }

    // Support tickets - for admin or support
    if (session?.user?.role === "admin" || session?.user?.role === "support") {
      items.push({
        id: "support-requests",
        icon: <SupportIcon />,
        label: t("common:menu.support-requests"),
        url: "/support/tickets",
        isRouteActive:
          location === "/support/tickets" ||
          location.includes("/support/tickets"),
      });

      items.push({
        id: "support-customers",
        icon: <PersonSearchOutlinedIcon />,
        label: t("common:menu.customers"),
        url: "/support/customers",
        isRouteActive:
          location === "/support/customers" ||
          location.includes("/support/customers"),
      });
    }

    // Support tickets - for customers
    if (session?.user?.role === "customer") {
      items.push({
        id: "support-tickets",
        icon: <SupportIcon />,
        label: t("common:menu.support-tickets"),
        url: "/company/support",
        isRouteActive:
          location === "/company/support" ||
          location.includes("/company/support"),
      });
    }

    // Profile menu - for all users
    items.push({
      id: "profile",
      icon: <BadgeOutlinedIcon />,
      label: t("common:menu.profile"),
      url: "/profile",
      isRouteActive: location === "/profile" || location.includes("/profile"),
    });

    // marketplace
    items.push({
      id: "marketplace",
      icon: <StoreOutlinedIcon />,
      label: t("common:menu.marketplace"),
      url: "/marketplace",
      isRouteActive:
        location === "/marketplace" || location.includes("/marketplace"),
    });

    // Billing menu - for all users
    items.push({
      id: "billing",
      icon: <ReceiptLongIcon />,
      label: t("common:menu.billing"),
      url: "/billing",
      isRouteActive: location === "/billing" || location.includes("/billing"),
    });

    // documentation
    items.push({
      id: "documentation",
      icon: <ArticleOutlinedIcon />,
      label: t("common:menu.documentation"),
      url: "https://docs.koolaber.ai",
      isExternal: true,
    });

    if (session?.user?.role === "admin") {
      items.push({
        id: "admin-changelog",
        icon: <ArticleOutlinedIcon />,
        label: "Changelog",
        url: "/admin/changelog",
        isRouteActive:
          location === "/admin/changelog" ||
          location.includes("/admin/changelog"),
      });
    }

    const sidebarOrder = [
      "dashboard",
      "companies",
      "all-companies",
      "subscriptions-mgmt",
      "user-management",
      "video-tutorials",
      "channels",
      "forms",
      "contacts",
      "whatsapp-chat",
      "inbox-kanban",
      "groups",
      "smart-reply",
      "bulk-sending",
      "workflows",
      "sales-acquisition",
      "automations",
      "marketplace",
      "bsmart-management",
      "settings",
      "support-requests",
      "support-customers",
      "support-tickets",
      "profile",
      "billing",
      "documentation",
      "admin-changelog",
    ];
    const orderedItems = sidebarOrder
      .map((id) => items.find((item) => item.id === id))
      .filter(Boolean);
    const remainingItems = items.filter(
      (item) => !sidebarOrder.includes(item.id),
    );
    return [...orderedItems, ...remainingItems];
  };

  const sidebarItems = buildSidebarItems();
  const [sidePanelWidth, setSidePanelWidth] = useState(0);

  return (
    <>
      {!embed && <Header />}

      <div className="layout-container d-flex min-vh-100">
        {/******** Sidebar **********/}
        {!embed && <aside className="sidebar-wrapper">
          <Sidebar
            items={sidebarItems}
            onPanelToggle={setSidePanelWidth}
            t={t}
          />
        </aside>}

        {/********Content Area**********/}
        <main
          className="content-wrapper d-flex flex-column flex-grow-1"
          style={{
            transition: "margin-left 0.3s ease",
            marginLeft: embed ? 0 : sidePanelWidth,
            minWidth: 0,
            overflowX: "hidden",
          }}
        >
          {/********topnav**********/}

          {!embed && !hideTopbar && <TopNav showMobmenu={() => showMobilemenu()} />}
          {/********Middle Content**********/}
          <div
            className="main-content position-relative border-radius-lg flex-grow-1"
            style={{
              marginLeft: embed ? 0 : "10px",
              minWidth: 0,
              overflowX: noContainer ? "hidden" : "auto",
              overflowY: noContainer ? "hidden" : undefined,
              display: noContainer ? "flex" : undefined,
              flexDirection: noContainer ? "column" : undefined,
            }}
          >
            {noContainer ? (
              renderedChildren
            ) : (
              <div className={`container-fluid ${embed ? "py-3" : "py-4"}`}>{renderedChildren}</div>
            )}
          </div>

          {/********Footer**********/}
          {!embed && !hideFooter && <Footer />}
        </main>
      </div>

      <ToastContainer
        position="top-right"
        autoClose={8000}
        hideProgressBar={false}
        newestOnTop={false}
        draggable={false}
        pauseOnVisibilityChange
        closeOnClick
        pauseOnHover
      />

      {/* Global WABA Call Widget — persists across navigation */}
      {!embed && <WabaCallWidget />}

      {/* Global Message Notification Widget — shows notifications across all pages */}
      {!embed && <MessageNotificationWidget />}
    </>
  );
};

export default AuthLayout;
